import type { TRuleWithTheme } from 'styles/theme';

export const tableContainer: TRuleWithTheme = ({ theme }) => ({
    backgroundColor: theme.colors.bgPrimary,
    padding: '1px 0',
    '& .ant-table-cell': {
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
    },
    '& Table': {
        borderCollapse: 'separate',
    },
    '& .ant-table': {
        backgroundColor: 'transparent',
    },
    '& .ant-table-container': {
        backgroundColor: 'transparent',
    },
    '& table': {
        backgroundColor: 'transparent',
    },
    '& .ant-table-tbody': {
        backgroundColor: 'transparent',
    },
    '& .ant-table-tbody > tr': {
        backgroundColor: 'transparent',
    },
    '& .ant-table-tbody > tr > td': {
        backgroundColor: 'transparent',
    },
    '& .ant-pagination': {
        paddingTop: '2rem !important',
    },
    '& .ant-card': {
        backgroundColor: 'transparent',
    },
    // @ant-design/pro-table wraps its content in a ProCard, which paints its
    // own solid white background over this container's gray by default.
    '& .ant-pro-card': {
        backgroundColor: 'transparent',
    },
    '& tr::after': {
        height: '0px !important',
    },
    '& .ant-table-tbody > tr:hover': {
        backgroundColor: 'transparent !important',
    },
    '& .ant-table-tbody > td:hover': {
        backgroundColor: 'transparent !important',
    },
    '& .ant-table-tbody > tr.ant-table-row:hover > td': {
        backgroundColor: 'transparent !important',
    },
});
